import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  onClick: VoidFunction;
};

export const RemoveAccessButton = ({ onClick }: Props) => (
  <ThemedButton
    className="w-full h-11 px-2 rounded-lg justify-start text-left hover:bg-background/secondary"
    dataTestId="remove-button"
    onClick={onClick}
    variant="tertiary"
  >
    <div className="flex flex-col">
      <span className="body-base-medium text-text/negative">
        {m.settings_removeAccess()}
      </span>
    </div>
  </ThemedButton>
);
